/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'

interface Props {
  id: string
  title: string
  description: string
  icon?: string
  confirmOnClickHandler: () => void
}

const DeleteConfirmationModal: FC<Props> = ({
  id,
  title,
  description,
  icon = 'bi-exclamation-circle',
  confirmOnClickHandler,
}) => {
  const intl = useIntl()
  const iconClass = `fs-1 text-danger ${icon}`

  return (
    <>
      <div className='modal fade' tabIndex={-1} id={id}>
        <div className='modal-dialog modal-lg'>
          <div className='modal-content'>
            <div className='modal-header border-0 pb-0'>
              <div className='d-flex flex-wrap align-items-center justify-content-start'>
                <div className='d-flex flex-column flex-row-fluid'>
                  <h5 className='modal-title'>{title}</h5>
                </div>
              </div>
            </div>

            <div className='modal-body mt-0 pt-3'>
              <div className='separator separator-dashed border-danger opacity-25 mt-2 mb-5'></div>

              <div className=''>
                {intl.formatMessage({id: 'UTIL.DELETE_CONFIRMATION.DESCRIPTION.L1'})} '
                <strong>{description}</strong>'.
                <br />
                {intl.formatMessage({id: 'UTIL.DELETE_CONFIRMATION.DESCRIPTION.L2'})}
              </div>
            </div>

            <div className='modal-footer border-0'>
              <button
                type='button'
                className='btn btn-sm btn-danger'
                data-bs-dismiss='modal'
                onClick={confirmOnClickHandler}
              >
                {intl.formatMessage({id: 'UTIL.CONFIRM'})}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {DeleteConfirmationModal}
